import { jsx as _jsx } from "react/jsx-runtime";
import AttendanceDetails from '../attendance/screens/DetailsScreen';
const routes = [
    {
        path: '/workshop-training-lookup',
        async lazy() {
            const { WorkshopTrainingLookup } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: WorkshopTrainingLookup };
        },
    },
    {
        path: '/batch-screen/details/:docId/:action',
        async lazy() {
            const { WorkshopBatchDetails } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: WorkshopBatchDetails };
        },
    },
    {
        path: '/workshop-form/:docId/:action',
        async lazy() {
            const { WorkshopForm } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: WorkshopForm };
        },
    },
    {
        path: '/workshop-training-lookup/details/:docId/:action',
        async lazy() {
            const { TrainingDetails } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: TrainingDetails };
        },
    },
    {
        path: '/workshop-type-lookup',
        async lazy() {
            const { WorkshopTypeLookup } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: WorkshopTypeLookup };
        },
    },
    {
        path: '/workshop-type-lookup/details/:docId/:action',
        async lazy() {
            const { TypeMaintenanceDetailsScreen } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: TypeMaintenanceDetailsScreen };
        },
    },
    {
        path: '/workshop-attendance-lookup',
        async lazy() {
            const { AttendanceLookup } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: AttendanceLookup };
        },
    },
    {
        path: '/workshop-attendance-lookup/details/:officerId',
        element: _jsx(AttendanceDetails, {}),
        // async lazy() {
        //   const { AttendanceDetails } = await import(
        //     /* webpackChunkName: "workshop" */
        //     './WorkshopLazyLoader'
        //   );
        //   return { Component: AttendanceDetails };
        // },
    },
    {
        path: '/workshop-move-hours',
        async lazy() {
            const { WorkshopMoveHours } = await import(
            /* webpackChunkName: "workshop" */
            './WorkshopLazyLoader');
            return { Component: WorkshopMoveHours };
        },
    },
];
export default routes;
